import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FloatingRobotIcon from "../../assets/images/floating_robot_ai.webm";
import FloatingRobotAi from "../../assets/Lotties/FloatingRobotAi.json";
import Lottie from "react-lottie";
import Button from "../UniversalComponents/DefaultButton";

export default function AestheticDialog({ open, onClose }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: FloatingRobotAi,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        className: "rounded-xl shadow-lg border border-gray-200 bg-white",
      }}
    >
      <div className="flex justify-end items-center px-6 pt-4 pb-2">
        <CloseIcon className="cursor-pointer" onClick={onClose} />
      </div>

      <div className="flex flex-col justify-center items-center gap-8">
        <div class="relative bg-[var(--color-primary)] font-light text-gray-200 px-4 py-2 text-[16px] rounded-2xl shadow">
          <span className="font-normal">Ask AI🤖</span> is currently under development
          <div class="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-full w-0 h-0 border-x-8 border-x-transparent border-t-8 border-t-[var(--color-primary)]"></div>
        </div>
        <Lottie options={defaultOptions} height={200} width={200} isClickToPauseDisabled />
      </div>
      <div className="flex flex-col justify-center items-center py-6 gap-8">
        <Button onClick={onClose} className="!w-[300px] mt-4">
          Ok
        </Button>
      </div>
    </Dialog>
  );
}
